export default "__VITE_ASSET__CQwDlrpu__"